import styled, { css } from 'styled-components';

export const Colors = styled.div`
    background-color: ${props => (props.backgroundColor ? props.backgroundColor : '#F6F6F6')};
    color: ${props => (props.textColor ? props.textColor : '#000')};
    min-height: ${props => (props.minHeight ? props.minHeight : 'auto')};
    border: 1px solid #c3ccd9;
`;

export const LinkColor = styled.a`
    && {
        color: ${props => (props.textColor ? props.textColor : '#000')};
    }
`;

export const ArrowDown = styled.div`
    border: 1px solid #06befb;
    background: #ffffff;
    color: #000000;
    right: ${props => (props.isMobile ? '10px' : '24px')};
    top: ${props => props.isMobile && '24px'};
    position: absolute;

    :hover,
    :focus {
        background: #f1f9ff;
        border: 2px solid #06befb;
        color: #000000;
        transition: all 0.5s ease;
    }
`;

export const Divider = styled.div`
    border: 1px solid ${props => (props.color ? props.color : '#c3ccd9')};
    height: 1px;
    width: 80%;
    margin: 0 auto;
`;

export const Logo = styled.img`
    max-width: 220px;
    max-height: 80px;
`;

export const CardWrapper = styled.div`
    display: grid;
    gap: 8px 8px;
    justify-items: ${props => (props.isMobile ? 'left' : 'center')};
    position: relative;

    @media (min-width: 600px) {
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    }

    @media (min-width: 1010px) {
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    }

    text-align: left;
    word-break: break-word;
`;

export const Contact = styled.div`
    display: grid;
    grid-template-columns: ${props => !props.noImages && !props.developerContact && !props.isMobile && '100px 240px'};
    grid-template-rows: ${props => props.developerContact && 'auto auto'};
    grid-gap: ${props => props.developerContact || (props.isMobile && '8px')};
`;

export const Column = styled.div`
    width: ${props => (props.isMobile ? '100% ' : '340px')};
`;

export const ProfileImageWrapper = styled.div`
    display: ${props =>
        (props.noImages && !props.developerContact) ||
        (props.developerContact && !props.hasImage) ||
        (props.financialAgent && props.isMobile)
            ? 'none'
            : 'block'};
    width: ${props => (props.developerContact ? '160px' : '80px')};
    height: 80px;
    position: relative;
    overflow: hidden;
    border-radius: ${props => (props.developerContact ? '0' : '50%')};
    background-color: ${props => props.hasImage && !props.developerContact && 'white'};
`;

export const ProfileImage = styled.img`
    display: block;
    max-height: 80px;
    max-width: ${props => (props.developerContact ? '160px' : '80px')};
    margin: ${props => !props.developerContact && 'auto'};
`;

export const ExternalLinks = styled.div`
    &&,
    a,
    p {
        width: fit-content;
    }
`;

export const CtaButton = styled.a`
    && {
        min-width: 100%;

        ${props =>
            props.ctaButtonColor &&
            css`
                color: ${props.ctaButtonColor.textColor};
                background-color: ${props.ctaButtonColor.backgroundColor};
                border-color: ${props.ctaButtonColor.backgroundColor};

                :active {
                    background-color: ${props.ctaButtonColor.backgroundActiveColor};
                    border-color: ${props.ctaButtonColor.backgroundActiveColor};
                }

                :hover {
                    background-color: ${props.ctaButtonColor.backgroundHoverColor};
                    color: ${props.ctaButtonColor.textHoverColor};
                    border-color: ${props.ctaButtonColor.backgroundHoverColor};
                }
            `}
    }
`;
